/* @flow */
import AdminGroupsContainer from './AdminGroupsContainer';

export default AdminGroupsContainer;
